// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__GW_cc","upload":"Small_upload__2iRh8","imageWrap":"Small_imageWrap__2eGu0","removeBtn":"Small_removeBtn__gN9oA"};